import React from 'react';

const STORAGE_MARKER = '/storage/v1/object/public/';
const DEFAULT_WIDTHS = [320, 480, 640, 960, 1280, 1600];

const isStoragePublicUrl = (src) => {
  if (!src || typeof src !== 'string') return false;
  if (!src.startsWith('http')) return false;
  return src.includes(STORAGE_MARKER);
};

const buildSizedUrl = (src, width) => {
  const url = new URL(src);
  url.searchParams.set('width', String(width));
  url.searchParams.set('quality', '78');
  return url.toString();
};

export default function ResponsiveImage({
  src,
  alt,
  className,
  sizes = '100vw',
  widths = DEFAULT_WIDTHS,
  loading = 'lazy',
  decoding = 'async',
  ...rest
}) {
  if (!src) return null;
  if (!isStoragePublicUrl(src)) {
    return <img src={src} alt={alt} className={className} loading={loading} decoding={decoding} {...rest} />;
  }

  const srcSet = widths.map((w) => `${buildSizedUrl(src, w)} ${w}w`).join(', ');
  return (
    <img
      src={buildSizedUrl(src, widths[Math.min(2, widths.length - 1)])}
      srcSet={srcSet}
      sizes={sizes}
      alt={alt}
      className={className}
      loading={loading}
      decoding={decoding}
      {...rest}
    />
  );
}
